const onCreate = ( status ) => {

    switch ( status ) {
        case 422:
            return {
                status: status,
                message: "creare il cliente: errore nei parametri di richiesta",
            } 
        default:
            return null;
    }

}

export default onCreate;